export default __webpack_public_path__ + "static/media/2169.905aa77f.png";